import React, { Component } from 'react';
import './A5.css';

class A5 extends Component{
    render(){
        return(    
        <div className="campoA5">{this.props.children}
        </div>
        )
    }

}

export default A5;